export interface Coordinate {
    lat?: number | null;
    lng?: number | null;
}

export interface StringCoordinate {
    lat?: string | null;
    lng?: string | null;
}

/**
 * 유효한 위/경도인지 검사 (숫자 타입)
 * - undefined/null 체크
 * - 0.0 좌표 체크 (GPS 미수신 시 0.0으로 들어옴)
 */
export const isValidCoordinate = (coord: Coordinate | undefined | null): coord is Coordinate & { lat: number; lng: number } => {
    if (!coord) return false;
    const { lat, lng } = coord;
    if (lat == null || lng == null) return false;
    if (lat === 0 || lng === 0) return false;
    return true;
};

/**
 * 유효한 위/경도인지 검사 (문자열 타입 - API 응답용)
 */
export const isValidStringCoordinate = (coord: StringCoordinate | undefined | null): boolean => {
    if (!coord) return false;
    const { lat, lng } = coord;
    if (!lat || !lng) return false;
    const latNum = parseFloat(lat);
    const lngNum = parseFloat(lng);
    if (isNaN(latNum) || isNaN(lngNum)) return false;
    if (latNum === 0 || lngNum === 0) return false;
    return true;
};

/**
 * 유효하지 않은 좌표에 대한 에러 메시지 반환
 */
export const getCoordinateErrorMessage = (coord: Coordinate | StringCoordinate | undefined | null): string => {
    if (!coord) return "위치 정보가 없습니다.";
    const { lat, lng } = coord;
    if (lat == null || lng == null) return "위치 정보가 없습니다.";

    const latNum = typeof lat === 'string' ? parseFloat(lat) : lat;
    const lngNum = typeof lng === 'string' ? parseFloat(lng) : lng;

    if (isNaN(latNum) || isNaN(lngNum)) return "위치 정보가 없습니다.";
    if (latNum === 0 || lngNum === 0) return "올바른 위/경도가 아닙니다.";
    return "";
};
